import React, { useCallback } from 'react';
import { MenuItem, Select } from '~/UIKit';
import { ListItemText, Checkbox } from '@mui/material';

interface IItemCreationMultiSelectProps {
  classes?: any;
  name: string;
  label: string | React.ReactElement | undefined;
  value?: any;
  renderValue: Function;
  setFieldValue: Function;
  disabled?: boolean;
  options?: any[];
}

export const ItemCreationMultiSelect = ({
  classes,
  name,
  value,
  label,
  renderValue,
  setFieldValue,
  disabled,
  options,
}: IItemCreationMultiSelectProps) => {
  const onChange = useCallback(
    (event: any) => {
      const addValue = value?.length ? [...value, event.target.value] : [event.target.value];
      const newValue = value?.includes(event.target.value)
        ? value.filter((item: any) => item !== event.target.value)
        : addValue;

      setFieldValue(name, newValue);
    },
    [value],
  );

  return (
    <Select
      className={classes.ItemCreationSubsectionInputMultiSelect}
      name={name}
      value={value || []}
      label={label}
      renderValue={renderValue}
      newDesign
      displayEmpty
      onChange={onChange}
      disabled={disabled}
    >
      {options?.map((option) => (
        <MenuItem value={option.value} key={name}>
          <Checkbox checked={option.selected} />
          <ListItemText primary={option.label} />
        </MenuItem>
      ))}
    </Select>
  );
};
